import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CASINO_CONFIGURATION_GAMES_SCOPE_QUERY_KEY } from "./casinoConfigurationGamesQueryKeys";
import {
  fetchPatchCasinoConfigurationGameDetails,
  type PatchCasinoConfigurationGameDetailsPayload,
} from "./patchCasinoConfigurationGameDetails";

export function usePatchCasinoConfigurationGameDetails() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: PatchCasinoConfigurationGameDetailsPayload) =>
      fetchPatchCasinoConfigurationGameDetails(payload),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: CASINO_CONFIGURATION_GAMES_SCOPE_QUERY_KEY,
      });
    },
  });
}
